import {
  YARIKANO_CHAT_ICON_URL,
  YARIKANO_CHAT_OPERATOR_UUID,
  YARIKANO_CHAT_TITLE,
  YARIKANO_CHAT_VIDEO_MIME,
} from '../../constants';
import {
  EUserProvider,
  TMember,
  TMessageDetail,
  EYarikanoChatLogKind,
  TYarikanoChatLogEntry,
} from 'types';

const MY_MESSAGE_UUID = 'yarikano-chat-male';
const YARIKANO_CHANNEL_ID = 'yarikano';

const noop = (): void => {};

const isTextLogKind = (kind: EYarikanoChatLogKind): boolean =>
  kind === EYarikanoChatLogKind.QUESTION ||
  kind === EYarikanoChatLogKind.ANSWER_TEXT;

const isQuestionLogKind = (kind: EYarikanoChatLogKind): boolean =>
  kind === EYarikanoChatLogKind.QUESTION;

const toPseudoMessage = (
  entry: TYarikanoChatLogEntry,
  isQuestion: boolean,
): TMessageDetail => {
  const message: {
    text?: string;
    media?: { type: string; url: string }[];
  } = {};

  if (isTextLogKind(entry.kind)) {
    message.text = entry.text ?? '';
  }

  if (
    entry.kind === EYarikanoChatLogKind.ANSWER_VIDEO &&
    entry.videoUrl
  ) {
    message.media = [
      {
        type: YARIKANO_CHAT_VIDEO_MIME,
        url: entry.videoUrl,
      },
    ];
  }

  return {
    channel: YARIKANO_CHANNEL_ID,
    uuid: isQuestion ? MY_MESSAGE_UUID : YARIKANO_CHAT_OPERATOR_UUID,
    timetoken: entry.timetoken,
    message,
  };
};

const getLogEntryDisplayText = (entry: TYarikanoChatLogEntry): string =>
  isTextLogKind(entry.kind) ? entry.text ?? '' : '';

const shouldShowOperatorAvatar = (
  entry: TYarikanoChatLogEntry,
  index: number,
  log: TYarikanoChatLogEntry[],
): boolean => {
  if (isQuestionLogKind(entry.kind)) return false;

  const prev = log[index - 1];
  return (
    index === 0 ||
    prev?.kind === EYarikanoChatLogKind.QUESTION ||
    prev?.kind === EYarikanoChatLogKind.ANSWER_CTA ||
    prev?.questionId !== entry.questionId
  );
};

const createOperatorMember = (): TMember => ({
  id: 0,
  uuid: YARIKANO_CHAT_OPERATOR_UUID,
  name: YARIKANO_CHAT_TITLE,
  avatar: YARIKANO_CHAT_ICON_URL,
  inactive: false,
  isSalonMember: false,
  isSalonPremiumMember: false,
  salonMembershipType: null,
  provider: EUserProvider.MANAGEMENT_APPLICATION,
  specialGameId: 0,
});

const createQuestionMessage = (
  text: string,
  timetoken: string,
): TMessageDetail => ({
  channel: YARIKANO_CHANNEL_ID,
  uuid: MY_MESSAGE_UUID,
  timetoken,
  message: { text },
});

export {
  MY_MESSAGE_UUID,
  noop,
  toPseudoMessage,
  getLogEntryDisplayText,
  shouldShowOperatorAvatar,
  createOperatorMember,
  createQuestionMessage,
  isQuestionLogKind,
};
